export default "__VITE_ASSET__fcnFGE1a__"